import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsSharesConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.facebook.reels_shares',
    tooltip: 'kpi.facebook.reels_shares_tooltip',
    id: 'reels_shares',
    icon: {
        name: 'share',
        style: colors.aquablue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
